import { render } from "./MapPosition.vue?vue&type=template&id=022af842&scoped=true&ts=true"
import script from "./MapPosition.vue?vue&type=script&lang=ts"
export * from "./MapPosition.vue?vue&type=script&lang=ts"

import "./MapPosition.vue?vue&type=style&index=0&id=022af842&lang=scss&scoped=true"

import exportComponent from "F:\\agent009\\_work\\569\\s\\sites\\easyestate\\easyestate.front\\ClientApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-022af842"]])

export default __exports__